export const GET_LIBRARY_REQUEST="GET_LIBRARY_REQUEST"
export const GET_LIBRARY_SUCCESS="GET_LIBRARY_SUCCESS"
export const GET_LIBRARY_FAILED="GET_LIBRARY_FAILED"

export const TEMPLATE_REQUEST="TEMPLATE_REQUEST"
export const TEMPLATE_SUCCESS="TEMPLATE_SUCCESS"
export const TEMPLATE_FAILED="TEMPLATE_FAILED"



export const GET_DISPLAY_REQUEST="GET_DISPLAY_REQUEST"
export const GET_DISPLAY_SUCCESS="GET_DISPLAY_SUCCESS"
export const GET_DISPLAY_FAILED="GET_DISPLAY_FAILED"

export const ADD_DISPLAY_REQUEST="ADD_DISPLAY_REQUEST"
export const ADD_DISPLAY_SUCCESS="ADD_DISPLAY_SUCCESS"
export const ADD_DISPLAY_FAILED="ADD_DISPLAY_FAILED"


export const UPLOAD_IMAGE="UPLOAD_IMAGE"
export const UPLOAD_SUCCESS="UPLOAD_SUCCESS"
export const UPLOAD_FAILED="UPLOAD_FAILED"
export const UPLOAD_INDEX="UPLOAD_INDEX"


export const DELETE_IMAGE="DELETE_IMAGE"
export const DELETE_SUCCESS="DELETE_SUCCESS"
export const DELETE_FAILED="DELETE_FAILED"

export const DELETE_DISPLAY="DELETE_DISPLAY"
export const DELETE_DISPLAY_SUCCESS="DELETE_DISPLAY_SUCCESS"
export const DELETE_DISPLAY_FAILURE="DELETE_DISPLAY_FAILURE"